/**
 * Loader action types
 */
export const LOADING = 'LOADING';
export const SAVING = 'SAVING';
export const COMPLETE = 'COMPLETE';
export const SET_PROGRESS = 'SET_PROGRESS';

/**
 * Infrastructure action types
 */
export const SET_MOBILE_MENU_VISIBILITY = 'SET_MOBILE_MENU_VISIBILITY';

/**
 * Localization action types
 */
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

/**
 * Identity action types
 */
export const IDENTITY_LOGIN_OK = 'IDENTITY_LOGIN_OK';
export const IDENTITY_LOGOUT_OK = 'IDENTITY_LOGOUT_OK';
export const IDENTITY_SET_FORCE_CHANGE_PASSWORD = 'IDENTITY_SET_FORCE_CHANGE_PASSWORD';
export const IDENTITY_UNSET_FORCE_CHANGE_PASSWORD = 'IDENTITY_UNSET_FORCE_CHANGE_PASSWORD';
export const IDENTITY_FORGOT_PASSWORD = 'IDENTITY_FORGOT_PASSWORD';
export const IDENTITY_RESET_PASSWORD_COMPLETE = 'IDENTITY_RESET_PASSWORD_COMPLETE';
export const IDENTITY_GET_ROLES = 'IDENTITY_GET_ROLES';
export const IDENTITY_SET_IMPERSONATE_ROLE = 'IDENTITY_SET_IMPERSONATE_ROLE';
export const IDENTITY_REMOVE_IMPERSONATE_ROLE = 'IDENTITY_SET_IMPERSONATE_ROLE';
export const IDENTITY_SELECT_ROLE = 'IDENTITY_SELECT_ROLE';
export const IDENTITY_UPDATE_ROLE_STATUS = 'IDENTITY_UPDATE_ROLE_STATUS';
export const IDENTITY_GET_USER_DETAILS = 'IDENTITY_GET_USER_DETAILS';
export const IDENTITY_GET_USER_PROFILE = 'IDENTITY_GET_USER_PROFILE';
export const IDENTITY_UPDATE_USER_DETAILS = 'IDENTITY_UPDATE_USER_DETAILS';
export const IDENTITY_GET_ADMIN_OK = 'IDENTITY_GET_ADMIN_OK';

/**
 * Background check action types
 */

export const BACKGROUND_CHECKS_GET_OK = 'BACKGROUND_CHECKS_GET_OK';
export const BACKGROUND_CHECK_CREATE_OK = 'BACKGROUND_CHECK_CREATE_OK';
export const BACKGROUND_CHECK_GET_OK = 'BACKGROUND_CHECK_GET_OK';
export const BACKGROUND_CHECK_UPDATE_OK = 'BACKGROUND_CHECK_UPDATE_OK';
export const BACKGROUND_CHECK_DELETE_OK = 'BACKGROUND_CHECK_DELETE_OK';
export const BACKGROUND_CHECK_LAUNCH_OK = 'BACKGROUND_CHECK_LAUNCH_OK';

/**
 * Position action types
 */
export const POSITIONS_GET_OK = 'POSITIONS_GET_OK';
export const POSITIONS_GET_SINGLE_OK = 'POSITIONS_GET_SINGLE_OK';
export const POSITIONS_SAVE_OK = 'POSITIONS_SAVE_OK';
export const POSITIONS_JOB_INVITATION_SENT_OK = 'POSITIONS_JOB_INVITATION_SENT_OK';

/**
 * Address action types
 */
export const ADDRESSES_GET_OK = 'ADDRESSES_GET_OK';
export const ADDRESSES_GET_SINGLE_OK = 'ADDRESSES_GET_SINGLE_OK';
export const ADDRESSES_SAVE_OK = 'ADDRESSES_SAVE_OK';
export const ADDRESSES_DELETE_OK = 'ADDRESSES_DELETE_OK';

/**
 * Approval action types
 */
export const APPROVALS_GET_OK = 'APPROVALS_GET_OK';
export const APPROVALS_GET_SINGLE_OK = 'APPROVALS_GET_SINGLE_OK';
export const APPROVALS_APPROVE_OK = 'APPROVALS_APPROVE_OK';
export const APPROVALS_APPROVE_IC_OK = 'APPROVALS_APPROVE_IC_OK';
export const APPROVALS_REJECT_OK = 'APPROVALS_REJECT_OK';
export const APPROVALS_RESET_OK = 'APPROVALS_RESET_OK';
export const APPROVALS_GET_CONTRACTOR_OK = 'APPROVALS_GET_CONTRACTOR_OK';

/**
 * User action types
 */
export const USER_GET_OK = 'USER_GET_OK';
export const USERS_GET_OK = 'USERS_GET_OK';
export const PAYSTUBS_GET_OK = 'PAYSTUBS_GET_OK';
export const PAYSTUB_GET_OK = 'PAYSTUB_GET_OK';
export const PAYDUES_GET_OK = 'PAYDUES_GET_OK';
export const PAYDUE_GET_OK = 'PAYDUE_GET_OK';
export const USERS_GET_ADMIN_DETAILS_OK = 'USERS_GET_ADMIN_DETAILS_OK';
export const USERS_GET_ADMINS_OK = 'USERS_GET_ADMINS_OK';

/**
 * Client action types
 */
export const CLIENTS_GET_OK = 'CLIENTS_GET_OK';
export const CLIENTS_GET_WORKERS_OK = 'CLIENTS_GET_WORKERS_OK';
export const CLIENT_GET_FEES_OK = 'CLIENT_GET_FEES_OK';
export const WORKER_UPDATE_OK = 'WORKER_UPDATE_OK';
export const CLIENT_FEE_CREATE_OK = 'CLIENT_FEE_CREATE_OK';
export const CLIENT_FEE_UPDATE_OK = 'CLIENT_FEE_UPDATE_OK';
export const CLIENT_FEE_DELETE_OK = 'CLIENT_FEE_DELETE_OK';

/**
 * Admin action types
 */
export const ADMIN_GET_WORKERS_OK = 'ADMIN_GET_WORKERS_OK';

/**
 * Documents action types
 */
export const DOCUMENTS_GET_ALL_OK = 'DOCUMENTS_GET_ALL_OK';
export const DOCUMENTS_CLEAR_ALL_OK = 'DOCUMENTS_CLEAR_ALL_OK';
export const DOCUMENTS_UNSET_ID = 'DOCUMENTS_UNSET_ID';
export const DOCUMENTS_SET_LOADING_TYPE = 'DOCUMENTS_SET_LOADING_TYPE';
export const DOCUMENTS_UNSET_LOADING_TYPE = 'DOCUMENTS_UNSET_LOADING_TYPE';
export const DOCUMENTS_GET_SIGNATURES_OK = 'DOCUMENTS_GET_SIGNATURES_OK';
export const DOCUMENTS_SET_REPLACE_DOC = 'DOCUMENTS_SET_REPLACE_DOC';
export const DOCUMENTS_DELETE_OK = 'DOCUMENTS_DELETE_OK';

/**
 * I9
 */
export const CREATED_I9 = 'CREATED_I9';
export const I9_GET_OK = 'I9_GET_OK';
export const I9_UPDATE_OK = 'I9_UPDATE_OK';
export const I9_SUBMIT_OK = 'I9_SUBMIT_OK';
export const I9_CREATE_OK = 'I9_CREATE_OK';

/**
 * Offer Lettter, IC Agreement, Assignment
 */
export const CREATED_JOBDOC = 'CREATED_OFFER';

/**
 * Projects action types
 */
export const PROJECTS_CREATE_OK = 'PROJECTS_CREATE_OK';
export const PROJECTS_GET_OK = 'PROJECTS_GET_OK';

/**
 * Invites action types
 */
export const INVITES_GET_ALL_OK = 'INVITES_GET_ALL_OK';
export const INVITES_GET_ROLES_OK = 'INVITES_GET_ROLES_OK';

/**
 * Jobs action types
 */
export const JOBS_GET_OK = 'JOBS_GET_OK';
export const JOB_GET_OK = 'JOB_GET_OK';
export const JOB_DELETE_OK = 'JOB_GET_OK';
export const JOB_TERMINATE_OK = 'JOB_TERMINATE_OK';
export const JOB_GET_WITH_CLIENT_OK = 'JOB_GET_WITH_CLIENT_OK';
export const JOB_UPDATE_OK = 'JOB_SET_OK';
export const JOB_SET_PROGRESS = 'JOB_SET_PROGRESS';

/**
 * Invoices action types
 */
export const INVOICES_GET_OK = 'INVOICES_GET_OK';
export const INVOICE_GET_OK = 'INVOICES_GET_OK';

/**
 * Payrolls action types
 */
export const PAYROLLS_GET_OK = 'PAYROLLS_GET_OK';

/**
 * Answer action types
 */
export const ANSWER_CREATE_OK = 'ANSWER_CREATE_OK';
export const ANSWER_SAVE_OK = 'ANSWER_SAVE_OK';
export const GET_FORMINSTANCE_QUESTIONS_OK = 'GET_FORMINSTANCE_QUESTIONS_OK';
export const GET_FORMTYPE_QUESTIONS_OK = 'GET_FORMTYPE_QUESTIONS_OK';

/**
 * Timekeeping action types
 */
export const TIME_CONFIRM_OK = 'TIME_CONFIRM_OK';
export const TIME_GET_RECORDS_OK = 'TIME_GET_RECORDS_OK';
export const TIME_UPDATE_RECORD_OK = 'TIME_UPDATE_RECORD_OK';
export const TIME_DELETE_RECORD_OK = 'TIME_DELETE_RECORD_OK';
export const TIME_GET_JOB_PROJECTS_OK = 'TIME_GET_JOB_PROJECTS_OK';
export const TIME_GET_PENDING_TIMESHEET_OK = 'TIME_GET_PENDING_TIMESHEET_OK';
export const TIME_GET_TIMESHEET_OK = 'TIME_GET_TIMESHEET_OK';
export const TIME_FIND_TIMESHEETS_OK = 'TIME_FIND_TIMESHEETS_OK';
export const TIME_GET_TIMESHEETS_SUMMARY_OK = 'TIME_GET_TIMESHEETS_SUMMARY_OK';
export const TIME_GET_TIMESHEETS_ALL_OK = 'TIME_GET_TIMESHEETS_ALL_OK';
export const TIME_GET_TIMESHEETS_NOTAPPROVED_OK = 'TIME_GET_TIMESHEETS_NOTAPPROVED_OK';
export const TIME_GET_TIMESHEETS_APPROVED_OK = 'TIME_GET_TIMESHEETS_APPROVED_OK';
export const TIME_GET_TIMESHEETS_PENDING_OK = 'TIME_GET_TIMESHEETS_PENDING_OK';
export const TIME_GET_PENDING_SHIFTS_OK = 'TIME_GET_PENDING_SHIFTS_OK';
export const TIME_GET_WORKER_TIMESHEET_SHIFTS_OK = 'TIME_GET_WORKER_TIMESHEET_SHIFTS_OK';
export const TIME_GET_WORKER_TIMESHEET_BILLINGS_OK = 'TIME_GET_WORKER_TIMESHEET_BILLINGS_OK';
export const TIME_GET_TIMESHEET_SHIFTS_OK = 'TIME_GET_TIMESHEET_SHIFTS_OK';
export const TIME_SUBMIT_TIMESHEET_OK = 'TIME_SUBMIT_TIMESHEET_OK';
export const TIME_SUBMIT_ALL_OK = 'TIME_SUBMIT_ALL_OK';
export const TIME_APPROVE_ALL_OK = 'TIME_APPROVE_ALL_OK';
export const TIME_SAVE_ENTRY_OK = 'TIME_SAVE_ENTRY_OK';
export const TIME_SAVE_RECORD_OK = 'TIME_SAVE_RECORD_OK';
export const TIME_TIMESHEET_APPROVED = 'TIME_TIMESHEET_APPROVED';

/**
 * Signatures action types
 */
export const SIGNATURES_GET_ALL_OK = 'SIGNATURES_GET_ALL_OK';
export const SIGNATURES_GET_SINGLE_OK = 'SIGNATURES_GET_SINGLE_OK';
export const SIGNATURES_GET_PREFERENCES_OK = 'SIGNATURES_GET_PREFERENCES_OK';
export const SIGNATURES_SET_PREFERENCES_OK = 'SIGNATURES_SET_PREFERENCES_OK';
export const SIGNATURES_SET_PREFERENCES_DIALOG_VISIBILITY = 'SIGNATURES_SET_PREFERENCES_DIALOG_VISIBILITY';

/**
 * Onboarding action types
 */
export const ONBOARDING_GET_JOB = 'ONBOARDING_GET_JOB';
export const ONBOARDING_GET_PROJECTS = 'ONBOARDING_GET_PROJECTS';
export const ONBOARDING_GET_POSITION = 'ONBOARDING_GET_POSITION';
export const ONBOARDING_GET_ADMIN = 'ONBOARDING_GET_ADMIN';
export const ONBOARDING_GET_CLASSIFICATION_OK = 'ONBOARDING_GET_CLASSIFICATION_OK';
export const ONBOARDING_CREATE_CLASSIFICATION_OK = 'ONBOARDING_CREATE_CLASSIFICATION_OK';
export const ONBOARDING_GET_CLASSIFICATION_QUESTIONS_OK = 'ONBOARDING_GET_CLASSIFICATION_QUESTIONS_OK';
export const ONBOARDING_GET_OFFER_LETTER_OK = 'ONBOARDING_GET_OFFER_LETTER_OK';
export const ONBOARDING_GET_ASSIGNMENT_LETTER_OK = 'ONBOARDING_GET_ASSIGNMENT_LETTER_OK';
export const ONBOARDING_GET_ARBITRATION_AGREEMENT_OK = 'ONBOARDING_GET_ARBITRATION_AGREEMENT_OK';
export const ONBOARDING_GET_EMPLOYEE_AGREEMENT_OK = 'ONBOARDING_GET_EMPLOYEE_AGREEMENT_OK';
export const ONBOARDING_GET_CONTRACTOR_AGREEMENT_OK = 'ONBOARDING_GET_CONTRACTOR_AGREEMENT_OK';

/**
 * Onboarding progression.
 */
export const ONBOARDING_PROGRESSION_SET_PROPERTIES = 'ONBOARDING_PROGRESSION_SET_PROPERTIES';
export const ONBOARDING_PROGRESSION_ALL_DONE = 'ONBOARDING_PROGRESSION_ALL_DONE';
export const ONBOARDING_PROGRESSION_INTRO_1_GET_SIGNATURE_OK = 'ONBOARDING_PROGRESSION_INTRO_1_GET_SIGNATURE_OK';
export const ONBOARDING_PROGRESSION_INTRO_1_SIGN_OK = 'ONBOARDING_PROGRESSION_INTRO_1_SIGN_OK';
export const ONBOARDING_PROGRESSION_INTRO_2_CHOOSE_CONTRACT_TYPE = 'ONBOARDING_PROGRESSION_INTRO_2_CHOOSE_CONTRACT_TYPE';

/**
 * Wizard action types
 */
export const WIZARD_CHANGE_MENU_STATE = 'WIZARD_CHANGE_MENU_STATE';
export const WIZARD_SET_PROGRESS = 'WIZARD_SET_PROGRESS';

/**
 * Wizard action types
 */
export const DIALOGS_SET_ROLE_SELECTOR_VISIBILITY = 'DIALOGS_SET_ROLE_SELECTOR_VISIBILITY';

/**
 * Tenants action types
 */
export const TENANTS_SET_MENU_ITEMS = 'TENANTS_SET_MENU_ITEMS';
export const TENANTS_SET_MENU_ITEM = 'TENANTS_SET_MENU_ITEM';
export const TENANTS_GET_INSTITUTION_REQUIREMENTS_OK = 'TENANTS_GET_INSTITUTION_REQUIREMENTS_OK';

/**
 * Notifications action types
 */
export const NOTIFICATIONS_GET_ALL_OK = 'NOTIFICATIONS_GET_ALL_OK';
export const NOTIFICATIONS_DISMISS_OK = 'NOTIFICATIONS_REMOVE';

/**
 * Banking action types
 */
export const BANKING_GET_BANKS_OK = 'BANKING_GET_BANKS_OK';
export const BANKING_CREATE_BANK_OK = 'BANKING_CREATE_BANK_OK';
export const BANKING_UPDATE_BANK_OK = 'BANKING_UPDATE_BANK_OK';
export const BANKING_DELETE_BANK_OK = 'BANKING_DELETE_BANK_OK';

/**
 * Classifications action types
 */
export const CLASSIFICATIONS_GET_ALL_OK = 'CLASSIFICATIONS_GET_ALL_OK';
export const CLASSIFICATIONS_GET_REF_OK = 'CLASSIFICATIONS_GET_REF_OK';
export const CLASSIFICATIONS_GET_SCORE_OK = 'CLASSIFICATIONS_GET_SCORE_OK';
export const FORM_INSTANCE_UPDATE_OK = 'FORM_INSTANCE_UPDATE_OK';



// WEBPACK FOOTER //
// ./src/reducers/types/index.js